import React, { useState, useEffect } from "react";
import { environment } from "../../environment";
import axios from "axios";
import { Button } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
const { SearchBar } = Search;

const MySwal = withReactContent(Swal);

const UserRolesIndexPage = () => {
  const [tenants, setTenants] = useState([]);
  useEffect(() => {
    // axios
    //   .get(
    //     environment.apiUrl +
    //       "tenantInfos?pageSize=200&page=0&sortProperty=createdTime&sortOrder=DESC",
    //     {
    //       headers: {
    //         "X-Authorization": "Bearer " + localStorage.getItem("token"),
    //       },
    //     }
    //   )
    // axios
    //   .get(environment.dap_url + "users/getAllTenant")
    //   .then((res) => {
    //     console.log("abc");
    //     console.log(res.data);
    //     setTenants(res.data);
    //     // setTenants(res.data.data);
    //   })
    //   .catch((err) => {});
  }, []);

  //   const deleteHandler = (id) => {
  //     // alert(id);
  //     MySwal.fire({
  //       title: "Are you sure?",
  //       icon: "warning",
  //       showCancelButton: true,
  //       confirmButtonText: "Yes",
  //     }).then(function (result) {
  //       if (result.isConfirmed) {
  //         axios
  //           .delete(environment.apiUrl + "tenant/" + id, {
  //             headers: {
  //               "X-Authorization": "Bearer " + localStorage.getItem("token"),
  //             },
  //           })
  //           .then((res) => {
  //             console.log(res.data.data);
  //             MySwal.fire({
  //               title: <p>Tenant has been successfully deleted!</p>,
  //               type: "success",
  //             });
  //             axios
  //               .delete(environment.dap_url + "partnerApi/deleteById?_id=" + id)
  //               .then((res) => {
  //                 // console.log(res.data.data);
  //                 MySwal.fire({
  //                   title: <p>Partner has been successfully deleted!</p>,
  //                   type: "success",
  //                 });
  //                 //history.push("/customers");
  //               })
  //               .catch((err) => {
  //                 MySwal.fire({
  //                   title: (
  //                     <p>
  //                       {err?.response?.data?.message ||
  //                         "Partner deletion failed"}
  //                     </p>
  //                   ),
  //                   type: "error",
  //                 });
  //               });
  //             //history.push("/customers");
  //             axios
  //               .get(environment.dap_url + "users/getAllTenant")
  //               .then((res) => {
  //                 console.log(res.data.data);
  //                 setTenants(res.data.data);
  //               })
  //               .catch((err) => {});
  //           })
  //           .catch((err) => {
  //             MySwal.fire({
  //               title: (
  //                 <p>
  //                   {err?.response?.data?.message || "Tenant deletion failed"}
  //                 </p>
  //               ),
  //               type: "error",
  //             });
  //           });
  //       }
  //     });
  //   };

  const columns = [
    {
      dataField: "",
      text: "Name",
      sort: true,
    },
    {
      dataField: "",
      text: "Role",
      sort: true,
    },
    {
      dataField: "email",
      text: "Email",
      sort: true,
    },
    {
      dataField: "phone",
      text: "Phone",
      sort: true,
    },
    {
      dataField: "",
      text: "DOB",
      sort: true,
    },
    {
      dataField: "country",
      text: "country",
      sort: true,
    },
    {
      dataField: "state",
      text: "state",
      sort: true,
    },
    {
      dataField: "city",
      text: "city",
      sort: true,
    },
    // {
    //   dataField: "zip",
    //   text: "zip",
    //   sort: true,
    // },
    // {
    //   dataField: "address",
    //   text: "Address",
    //   sort: true,
    // },
    {
      dataField: "userId",
      text: "Action",
      sort: false,
      formatter: (dataField) => {
        return (
          <div>
            <Button
              variant="danger"
              className="btn-sm"
              //   onClick={() => deleteHandler(dataField)}
            >
              Delete <i className="fa fa-trash-o"></i>
            </Button>
          </div>
        );
      },
    },
  ];

  const defaultSorted = [
    {
      dataField: "id",
      order: "desc",
    },
  ];

  return (
    <div>
      <div className="row" style={{ marginTop: "72px" }}>
        <div className="col-lg-12">
          <LinkContainer
            to={`/adduser/create`}
            style={{
              float: "right",
              //paddingTop: "18px",
              marginBottom: "20px",
            }}
          >
            <Button variant="light" className="btn-lg">
              Add Users
            </Button>
          </LinkContainer>
        </div>
      </div>

      <div>
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-body">
                <h4 className="card-title">ADD USERS</h4>
                <div className="row">
                  <div className="col-12">
                    <ToolkitProvider
                      keyField="id"
                      bootstrap4
                      data={tenants}
                      columns={columns}
                      search
                    >
                      {(props) => (
                        <div>
                          <div className="d-flex align-items-center">
                            <p className="mb-2 mr-2">Search in table:</p>
                            <SearchBar {...props.searchProps} />
                          </div>
                          <BootstrapTable
                            defaultSorted={defaultSorted}
                            pagination={paginationFactory()}
                            {...props.baseProps}
                            wrapperClasses="table-responsive"
                          />
                        </div>
                      )}
                    </ToolkitProvider>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserRolesIndexPage;
